import { render, staticRenderFns } from "./SectorAddModal.vue?vue&type=template&id=7679b94e"
import script from "./SectorAddModal.vue?vue&type=script&lang=js"
export * from "./SectorAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports